import type { ConflictDetailDialogProps } from "./types-conflict-detail-dialog";
import { ConflictDetailDialogView } from "./view-conflict-detail-dialog";

/** Tooltip "Conflito Detectado": uma linha por obra, com o início e o término da sobreposição. */
export function ConflictDetailDialog(props: ConflictDetailDialogProps) {
  return <ConflictDetailDialogView {...props} />;
}

export type * from "./types-conflict-detail-dialog";
